import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../queryKeys';
import useAxios from '../../hooks/useAxios';
import { Project } from '../../Models/Project';
import { ADMIN_PROJECT_LIST_URL } from '../../utils/constant';
import { Withdrawal } from '../../interface/Withdrawal.interface';

interface ProjectData {
  uuid?: string;
  _id?: string;
  name: string;
  description?: string;
  startDate: string | Date;
  endDate: string | Date;
  dueDay: number;
  status: string;
  currency: string;
  penaltyPerDay?: number;
  cashFundAmount?: number;
  penaltyAmountPerDay?: number;
  activated?: boolean;
  contribution: number;
  withdrawalAmount: number;
  withdrawalDay: number;
  share?: number;
  participants?: number;
  Users?: unknown[];
  Withdrawals?: Withdrawal[];
}

export function useProjects() {
  const { getWithAxios } = useAxios();

  return useQuery({
    queryKey: queryKeys.projects.list(),
    queryFn: async (): Promise<Project[]> => {
      const response = await getWithAxios(ADMIN_PROJECT_LIST_URL);
      const projectsData = Array.isArray(response?.data) ? response.data : [];

      return projectsData.map((p: ProjectData) => {
        const projectId = p.uuid ?? p._id ?? '';
        return new Project({
          uuid: projectId,
          participants: p.participants || 0,
          name: p.name,
          description: p.description,
          startDate: new Date(p.startDate),
          endDate: new Date(p.endDate),
          dueDay: p.dueDay,
          status: p.status,
          currency: p.currency,
          penaltyPerDay: p.penaltyPerDay,
          cashFundAmount: p.cashFundAmount,
          penaltyAmountPerDay: p.penaltyAmountPerDay,
          activated: p.activated,
          contribution: p.contribution,
          withdrawalAmount: p.withdrawalAmount,
          withdrawalDay: p.withdrawalDay,
          share: p.share || 0,
          Users: [],
          Withdrawals: p.Withdrawals || [],
        });
      });
    },
    staleTime: 5 * 60 * 1000,
  });
}
